import React from "react";
import { Container } from "reactstrap";
import { RouteComponentProps } from "react-router";
import { FeedbackCategory, FeedbackSortOption } from "../../../Feedback/Constants/feedbackEnums";
import FeedbackListContainer from "../../../Feedback/Components/Common/FeedbackList/FeedbackListContainer";

type TParams = {
  username: string;
};

const RESOURCE_REQUEST = [FeedbackCategory.ResourceRequest];

export const UserProfileResourceRequestsContainer: React.FC<RouteComponentProps<
  TParams
>> = props => (
  <Container fluid>
    <FeedbackListContainer
      listId={`APP_USER_PROFILE_ALL_RESOURCE_REQUESTS_LIST${props.match.params.username}`}
      sort={FeedbackSortOption.DateCreated}
      isAscending={false}
      reorderable
      username={props.match.params.username}
      fullscreen
      enableDownload
      selectedCategories={RESOURCE_REQUEST}
    />
  </Container>
);

export default UserProfileResourceRequestsContainer;
